import passwordValidator from "../../../shared/utils/password-validator";

export const isPasswordValid = (password) =>
  passwordValidator.uppercase(password) &&
  passwordValidator.lowercase(password) &&
  passwordValidator.minLength(password) &&
  passwordValidator.numeric(password);
